// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { TrashIcon } from '@/icons';
import { Button, Popover } from '@/ui';
import { PopoverOverlayGlobalStyles, StyledBulkActionsBar } from './FaqBulkActionsBarStyles';

type TFaqBulkActionsBarProps = {
  selectedCount: number;
  onDeleteSelected: () => void;
};

const FaqBulkActionsBar: FC<TFaqBulkActionsBarProps> = ({ selectedCount, onDeleteSelected }) => {
  const { t } = useTranslation();

  return (
    <StyledBulkActionsBar>
      {!!selectedCount && <p>{t('selected_faqs', { count: selectedCount })}</p>}
      <Popover
        rootClassName="bulk-delete-popover"
        title={!selectedCount ? t('select_items_to_delete') : null}
        trigger="hover"
      >
        <Button onClick={onDeleteSelected} disabled={!selectedCount} type="primary" icon={<TrashIcon />} danger>
          {t('btn_delete_selected')}
        </Button>
        <PopoverOverlayGlobalStyles />
      </Popover>
    </StyledBulkActionsBar>
  );
};

export default FaqBulkActionsBar;
